import React, { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { useNavigate } from "react-router-dom";
import { IconContext } from 'react-icons';
import { IoChevronForward } from "react-icons/io5";
import { IoChevronDown } from "react-icons/io5";

import Header from "../components/Header";
import Footer from "../components/Footer";
import CustomDropdown from "../components/CustomDropdown";

import { blogs, blogCategories } from '../constants/blog';

import "./Blog.css";

const Blog = () => {

    const { category } = useParams();
    const navigate = useNavigate();

    // Get the formatted title from the list of the blog categories
    const formattedTitle = blogCategories.filter(blogCategory => blogCategory.title == category)[0].formattedTitle;
    const formattedDescription = blogCategories.filter(blogCategory => blogCategory.title == category)[0].description;

    const [blogsToShow, setBlogsToShow] = useState([]);

    useEffect(() => {
        // Set the blogs to show based on the category
        setBlogsToShow(blogs.filter(blog => blog.category == category));
    }, [category])

    return (
        <section className="home-page-section" id="blog-page-container">

            <Header />

            <Helmet>
                <title>{"SP Labs Blog"}</title>
                <meta name="description" content={"The Superpowered team's perspective on all things LLMs and retrieval augmentation."} />
                <meta name="keywords" content={""} />
            </Helmet>

            <div className="blog-page-container">

                <div className="blog-page-left-sidebar">
                    <p id="blog-learn-text">Learn</p>
                    {blogCategories.map((blogCategory, index) =>
                        <div key={index}>
                            <BlogCategory
                                category={blogCategory.formattedTitle}
                                blogs={blogs.filter(blog => blog.category == blogCategory.title)}
                                onTitleClick={() => navigate(`/${blogCategory.title}`)}
                                isSelected={category == blogCategory.title}
                            />
                        </div>
                    )}
                </div>

                <div className="blog-page-main-section">

                    <div>

                        <div className="blog-category-dropdown">
                            <CustomDropdown
                                valueList={blogCategories.map(blogCategory => blogCategory.title)}
                                textList={blogCategories.map(blogCategory => blogCategory.formattedTitle)}
                                value={category}
                                sendDataToParent={(value) => navigate(`/${value}`)}
                                customStyle={{ width: "auto", margin: "auto" }}
                            />
                        </div>

                        <div className="blog-header-container">
                            <p className="blog-main-header-text">{formattedTitle}</p>
                            <p className="" id="blog-sub-header-text">
                                {formattedDescription}
                            </p>
                        </div>

                        <div className="blog-main-container">

                            {blogsToShow.map((blog, index) =>
                                <Insight
                                    image={blog.image}
                                    index={index}
                                    headerText={blog.title}
                                    text={blog.headerSubText}
                                    onClick={() => navigate(`/learn/${blog.formattedTitle}`)}
                                />
                            )}
                        </div>
                    </div>

                </div>

            </div>

            <Footer />

        </section>
    )

}



export const BlogCategory = ({ category, blogs, isSelected, onTitleClick, defaultIsOpen = false, currentBlogTitle = "" }) => {

    const navigate = useNavigate();

    const [isOpen, setIsOpen] = useState(defaultIsOpen);

    useEffect(() => {
        setIsOpen(defaultIsOpen);
    }, [defaultIsOpen])

    return (
        <div className="blog-category-container">
            <div className="blog-category-row">
                <div className="chevron-icon-container" onClick={() => setIsOpen(!isOpen)}>
                    <IconContext.Provider
                        value={{ className: "chevron-icon" }}>
                        {(isOpen) ? <IoChevronDown /> : <IoChevronForward />}
                    </IconContext.Provider>
                </div>
                <p className={`blog-category-text ${(isSelected && currentBlogTitle === "") ? "blog-category-text-selected" : ""}`}
                    onClick={onTitleClick}>
                    {category}
                </p>
            </div>

            <div className="blogs-list-container">
                {isOpen && blogs.map((blog, index) =>
                    <div key={index} onClick={() => navigate(`/learn/${blog.formattedTitle}`)}>
                        <p className={`blog-category-title-text ${(currentBlogTitle == blog.formattedTitle) ? "blog-category-title-text-selected" : ""}`}>
                            {blog.title}
                        </p>
                    </div>
                )}
            </div>
        </div>
    )
}



const Insight = ({ image, headerText, text, onClick, index }) => {

    return (
        <div className="blog-insight-container" onClick={onClick} key={index}>
            <div className="insight-image-col">
                <img className="blog-insight-image" loading="lazy" src={image == "" ? null : require(`../assets/blogImages/${image}`)} />

            </div>
            <div className="insight-content-col">
                <div className="insight-header-row">
                    <p className="insight-header-text">{headerText}</p>
                </div>
                <div className="insight-text-row">
                    <p className="insight-text">{text}</p>
                </div>
            </div>
        </div>
    )

}

/*export const BlogPost = ({ blog, darkTheme = false }) => {

    const navigate = useNavigate();

    const image = blog.image;

    return (
        <div className="blog-container" onClick={() => navigate(`/blog/${blog.formattedTitle}`)}>
            <div className="blog-page-image-col">
                <div>
                    <img className="blog-page-image" loading="lazy" src={image == "" ? null : require(`../assets/blogImages/${image}`)} />
                </div>
            </div>
            <div className="blog-page-main-col">
                <p className={`blog-title-text${darkTheme ? "-dark" : ""}`}>{blog.title}</p>
                <p className={`blog-page-date-text${darkTheme ? "-dark" : ""}`}>{blog.date}</p>
            </div>
        </div>
    )

}*/


export default Blog;